import React from 'react';
import { motion } from 'framer-motion';
import type { Aggregates } from '../../../types/pulse';
import { openResult } from '../../../data/pulse';
import { relatedThemes } from '../../../utils/pulse';
interface OpenResultScreenProps {
  aggregates: Aggregates;
  answer: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function OpenResultScreen({
  aggregates,
  answer
}: OpenResultScreenProps) {
  const cluster = relatedThemes(aggregates, answer, 3);
  return <div className="flex flex-1 flex-col" data-id="element-238" data-mp="l1ot1a778n24">
      <motion.h2 initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="font-display text-[24px] font-semibold leading-[1.1] tracking-tight text-navy" data-id="element-239" data-mp="q3nycpmi1u1p">
        {openResult.headline}
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.24,
      delay: 0.06,
      ease: EASE
    }} className="mt-5 rounded-xl border border-blue/40 bg-blue/[0.06] px-4 py-3.5" data-id="element-240" data-mp="2bz1cvyqghef">
        <p className="text-[9px] uppercase tracking-micro text-blue" data-id="element-241" data-mp="3umatzj5w9ipx">{openResult.recapLead}</p>
        <p className="mt-1.5 text-[13.5px] leading-relaxed text-navy" data-id="element-242" data-mp="3uonarszx1n1e">“{answer.trim()}”</p>
      </motion.div>

      <p className="mt-6 text-[12.5px] leading-relaxed text-navy2" data-id="element-243" data-mp="3kwhlir11tjpw">{openResult.clusterLead}</p>

      <div className="mt-3 flex flex-wrap gap-1.5" data-id="element-244" data-mp="3guwbddfwfjje">
        {cluster.map((theme, i) => <motion.span key={theme.id} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.22,
        delay: 0.12 + i * 0.06,
        ease: EASE
      }} className="rounded-full border border-line bg-mist px-3 py-1.5 text-[11.5px] leading-none text-navy" data-id="element-245" data-mp="3gsjlme3wg4vs" data-mpi={i}>
            {theme.label}
            <span className="ml-1.5 tabular-nums text-mut" data-id="element-246" data-mp="154toywpy5t7m">{theme.count}</span>
          </motion.span>)}
      </div>

      <p className="mt-auto pt-6 text-[10.5px] leading-snug text-mut" data-id="element-247" data-mp="104fqa5a8jvm9">
        {openResult.note} {aggregates.openResponses} open responses so far.
      </p>
    </div>;
}